import { Fragment, useState } from "react";
import BoxShadow from "../../../../Panel/Common/Components/BoxShadow";
import { FilledStarIcon } from "../../../component/Icons";
import style from './SingleAppStyles.module.scss'

import { CiLocationOn } from "react-icons/ci";
import { Link } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import { sepMoney } from "../../../../Web/Common/Function";
import { Information, Possibilities, RefundList } from "../../../../Web/View/Item/Components/Details";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { BsReverseLayoutTextWindowReverse } from "react-icons/bs";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { VscLaw } from "react-icons/vsc";
import { Tb24Hours, TbSitemap } from "react-icons/tb";
import { GoCommentDiscussion } from "react-icons/go";
import Commonets from "../../../../Web/Common/Comments";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import LinkBox from "../../../Panel/components/LinkBox";
import Time from "../../../../Web/View/Item/Components/Time/index";

import { HiArrowSmRight } from "react-icons/hi";
import CustomModal from "../../../../Panel/Common/Components/Modal/CustomModal";
import { RtlMui } from "../../../component/rtlMui";
import { toast } from "react-hot-toast";
import Slider from "../../../component/Slider";
import { useSelector } from "react-redux";
import StartPage from "../../Auth";

const SingleApp = ({ data, details, timetableRef, isWebview }) => {
    const item = data.data.Items;
    const [showResrve, setShowResrve] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [showTimeTable, setShowTimeTable] = useState(false);
    const [showGPS, setShowGPS] = useState(false);

    const { user_type } = useSelector(state => state);

    const linkList = [
        { label: "رزرو بلیت", link: "", onClick: function () { setShowTimeTable(!showTimeTable) } },
        // { label: "پک", link: "" },
        // { label: "کلاس های ورزشی", link: "" }
    ]
    if (showLogin && !user_type) {
        return (
            <StartPage isWebview={isWebview} />
        )
    }
    return (
        <div className={"bg-light " + (style.singlePage)}>
            <div className="allLtr">
                <Slider sp={item?.images} />
                {/* <img src={item?.images[0]} width={"100%"} /> */}
            </div>

            <div className={style.titleBox}>
                <BoxShadow className={"p-0 "}>
                    <div className="d-flex align-items-center">

                        {/* باکس جنسیت و امتیاز  */}
                        <div className="p-2">
                            <div className="genderBox">
                                <div className="border-bottom pb-2 px-1 d-flex">
                                    <img src="/img/app-home/icons-woman.png" width={"16px"} />
                                    <img src="/img/app-home/icons-man.png" width={"16px"} />
                                </div>
                                <div className="text-center">
                                    <span>
                                        <FilledStarIcon />
                                    </span>
                                    <span className="font-weight-light nfs-11">{Math.ceil(item?.comments_avg_score) || 5}</span>
                                </div>
                            </div>
                        </div>

                        {/* باکس نام و قیمت  */}
                        <div>
                            <p className="nfs-14 mb-2">{item.name}</p>
                            {item.header_price
                                ? <p className="nfs-10 text76">شروع قیمت از {sepMoney(item.header_price)} هزار تومان</p>
                                : <p className="nfs-10 text76"> قیمت ثبت نشده </p>
                            }

                        </div>

                        {/* باکس تخفیف  */}
                        {item?.off &&
                            <div className="nfs-14 text-center boxOffer">
                                <p className=" textDD3951">
                                    تا
                                    <span className="fs24 mr-1">
                                        {`٪${Math.ceil(item?.off?.offpersentage)}`}
                                    </span>
                                </p>
                                <p className="text-center">
                                    تخفیف
                                </p>
                            </div>
                        }

                    </div>

                    <div className="b-dash d-flex align-items-start px-2 py-3">
                        <CiLocationOn size={22} />
                        <p className="nfs-13 text76 mr-2 ellipsisAddress">{item.address}</p>
                        <Link className="nfs-13 txtBlue mr-auto text-left" style={{ flex: "0 0 80px" }} onClick={e => setShowGPS(true)}>
                            مسیریابی
                            <FiChevronLeft size={22} />
                        </Link>
                    </div>
                    <div className="border-top d-flex align-items-center px-2 py-2 PossibilitiesBox">
                        <Accordion className="mb-2">
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content" id="panel2a-header" >

                                <span> <TbSitemap size={"21px"} className="me-1" />امکانات و ویژگی ها</span>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Possibilities
                                    description={item.description}
                                    name={item.name}
                                    item={item}
                                    details={details}
                                />
                            </AccordionDetails>
                        </Accordion>

                    </div>
                </BoxShadow>
            </div>

            {item?.necessary_description &&
                <div className="bg-white py-3 px-2">
                    <p className="nfs-12">شرایط استفاده</p>
                    <p className="nfs-10 mt-2">
                        <Information description={item?.necessary_description} />
                    </p>
                </div>
            }

            <div className={style.accordionBox}>

                <Accordion className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content" id="panel1a-header" >
                        <span> <BsReverseLayoutTextWindowReverse size={"21px"} className="me-1" /> توضیحات</span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Information
                            description={item.description}
                            name={item.name}
                            item={item}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <VscLaw size={"21px"} className="me-1" /> قوانین و مقررات </span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Information description={item.rules ? item.rules : data.data.itemRules} />
                    </AccordionDetails>
                </Accordion>

                <Accordion className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <Tb24Hours size={"21px"} className="me-1" />  شرایط استرداد </span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <RefundList prdId={item.id} />
                    </AccordionDetails>
                </Accordion>

                <Accordion className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content" id="panel2a-header" >
                        <span> <GoCommentDiscussion size={"21px"} className="me-1" /> نظرات کاربران</span>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Commonets isApp={true} comments={data.data.Comments} id={item.id} rel="Item" />
                    </AccordionDetails>
                </Accordion>

            </div>

            <div className={style.parentReservBox}>
                {!showResrve &&
                    <div className={style.reservBox} onClick={() => {
                        if (user_type) {
                            setShowResrve(!showResrve);
                        }
                        else {
                            setShowLogin(true);
                        }
                    }}>
                        {user_type ? "رزرو بلیت و خدمات" : "ورود یا ثبت نام"}
                        <IoMdArrowDropup className="arrowAbsolute" size={24} />
                    </div>
                }
                {showResrve &&
                    <div className={style.reservBox2} >

                        {/* عکس مجموعه  */}
                        <div>
                            <img src={item?.images[0]} width={"100%"} />
                        </div>

                        {/* لیست دکمه ها  */}
                        <div className="px-3 mt-3 toTopAnimate">
                            {linkList.map(item => (
                                <LinkBox data={item} />
                            ))}
                        </div>

                        {/* نمایش تایم تیبل  */}
                        {showTimeTable &&
                            <div className={style.timeTableBox}>

                                <div className={style.btnBack} onClick={() => {
                                    setShowTimeTable(!showTimeTable)
                                }}>
                                    <HiArrowSmRight className="arrowAbsolute" size={28} />
                                </div>
                                <div className="p-2 timeBox">
                                    <RtlMui>
                                        <Time isApp={true} item={item} timeTable={data.data.timetable} timetableRef={timetableRef} />
                                    </RtlMui>
                                </div>
                            </div>
                        }

                        <div className={style.reservBox} onClick={() => {
                            setShowResrve(!showResrve)
                        }}>
                            بازگشت
                            <IoMdArrowDropdown className="arrowAbsolute" size={24} />
                        </div>
                    </div>
                }
            </div>

            <CustomModal
                show={showGPS}
                handleClose={() => {
                    setShowGPS(false);
                }}
                header={item.name}
                className={"modalCodeWallet"}
            >
                <p className="nfs-12">
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-2" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z" stroke="black" /> <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="black" stroke="black" /> <path d="M12 5V3" stroke="black" strokeLinecap="round" /> <path d="M19 12H21" stroke="black" strokeLinecap="round" /> <path d="M12 21V19" stroke="black" strokeLinecap="round" /> <path d="M3 12H5" stroke="black" strokeLinecap="round" /> </svg>
                    {item.address}
                </p>

                <button className="btn btn-primary w-100 mt-3 mb-2" style={{ borderRadius: "18px" }}
                    onClick={() => {
                        if (item.location) {
                            const loc = item.location.split(",")
                            window.open(`geo:0,0?q=${loc[0]},${loc[1]}`);
                        }
                        else {
                            toast.error("موقعیت مکانی برای این مجموعه ثبت نشده");
                        }
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-2" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z" stroke="white" /><path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="white" stroke="white" /><path d="M12 5V3" stroke="white" strokeLinecap="round" /><path d="M19 12H21" stroke="white" strokeLinecap="round" /><path d="M12 21V19" stroke="white" strokeLinecap="round" /><path d="M3 12H5" stroke="white" strokeLinecap="round" /></svg>
                    مسیر یابی
                </button>

            </CustomModal>

        </div >
    );
}

export default SingleApp;